import { render } from "./NotificationBlock.vue?vue&type=template&id=0e0f15df"
import script from "./NotificationBlock.vue?vue&type=script&lang=js"
export * from "./NotificationBlock.vue?vue&type=script&lang=js"

import "./NotificationBlock.vue?vue&type=style&index=0&id=0e0f15df&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__